import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../Utilities/AuthContext";
import PoweredBy from "../ReusableComponents/PoweredBy";

const VerifyMagicLink = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const verify = async () => {
      const token = searchParams.get("token");
      const email = searchParams.get("email");

      if (!token || !email) {
        setErrorMessage("Invalid login link.");
        setStatus("error");
        return;
      }

      try {
        const response = await fetch("/api/auth/verifyMagicLink", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, email }),
        });

        if (response.ok) {
          const data = await response.json();
          setStatus("success");
          // Small delay so user sees the success state
          setTimeout(() => {
            login(data.sessionToken, data);
          }, 500);
        } else {
          const errorData = await response.json();
          setErrorMessage(errorData.error || "Invalid or expired login link.");
          setStatus("error");
        }
      } catch {
        setErrorMessage("Unable to verify. Please check your internet connection.");
        setStatus("error");
      }
    };

    verify();
  }, [searchParams, login]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-dark via-primary to-primary-light flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white tracking-tight">GolfPools</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {status === "verifying" && (
            <div className="text-center py-8">
              <svg className="animate-spin h-12 w-12 text-primary mx-auto mb-4" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">Signing You In...</h2>
              <p className="text-gray-500">Just a moment</p>
            </div>
          )}

          {status === "success" && (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">You're In!</h2>
              <p className="text-gray-500">Redirecting to your dashboard...</p>
            </div>
          )}

          {status === "error" && (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">Link Invalid</h2>
              <p className="text-gray-600 mb-6">{errorMessage}</p>
              <Link
                to="/auth/login"
                className="inline-block bg-primary hover:bg-primary-hover text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                Request a New Link
              </Link>
            </div>
          )}
        </div>
        </div>
      </div>
      <PoweredBy variant="light" />
    </div>
  );
};

export default VerifyMagicLink;
